import React from "react";
import Reserve from "../modules/ReservePage/pages/Reserve";

export default function ReservePage(props) {
    let dates = props.match.params.date.split(',');
    return <Reserve
        date={dates[0]}
        date2={dates[1] === undefined ? null : dates[1]}
        count={props.match.params.count}
        source_id={props.match.params.source_id}
        dest_id={props.match.params.dest_id}
        travel_id={props.match.params.travel_id}
        back_travel_id={props.match.params.back_travel_id === undefined?null:props.match.params.back_travel_id}
    />;
}
